<template>
  <crud-editor
    ref="editor"
    :definition="definition"
    :is-edit="false"
    :auto-generated-id="false"
    :save="saveData"
    :return-to="returnTo"
    :item-type="entity"
    :get-layout="layout"
  />
</template>

<script>
import CrudEditor from '@/components/crud/TabbedEditor';
import formMixin from './form-mixin';
import { getCreateLayoutDefinition } from './form.js';

export default {
  components: {
    CrudEditor
  },
  mixins: [formMixin],
  data() {
    return {
      layout: getCreateLayoutDefinition
    };
  },
  methods: {
    saveData(form) {
      const item = this.createItemFromFormData(this, form);
      item.clientID = Number(this.$route.params.clientID);
      return this.$store.dispatch(this.entityStore + '/persistItem', item);
    }
  }
};
</script>
